import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import { appPaths } from 'config';

const Logo = ({ to, at, className, textClass, ...rest }) => {
  return (
    <Link
      to={to || appPaths.index}
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <span className={classNames('font-sans-serif', textClass)}>
          SwarmNode
        </span>
      </div>
    </Link>
  );
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
